/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const ITEMS_PER_PAGE = 'Rows per page:';
export const LABELS = {
  DISPLAY_NAME: 'Display Name',
  LOCATION_NAME: 'Sub-Realm',
  LOCATION_TYPE: 'Sub-Realm Type',
  LOCATION_ADDRESS: 'Sub-Realm Address',
  PASSWORD_POLICY: 'Password Policy'
};
export const EDIT_LOCATION = 'Edit Sub-Realm';
export const DELETE_LOCATION = 'Delete Sub-Realm';
export const VIEW_PASSWORD_POLICY = 'View Password Policy';
